// Import model
import { SfRoom } from '../models/SfRoom';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfRoom - handles JSON serialization and deserialization with type validation
 */
export class SfRoomSerializer {
  /**
   * Deserializes a JSON string into a SfRoom instance
   */
  static deserialize(json: string): SfRoom {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfRoom instance
   */
  static fromObject(obj: any): SfRoom {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfRoom');
    }


    const instance: SfRoom = {
      externalId: obj['externalId'] as string | undefined,
      isDeleted: obj['isDeleted'] as boolean | undefined,
      floorplanExternalId: obj['floorplanExternalId'] as string | undefined,
      floorplanExternalIdName: obj['floorplanExternalId|Name'] as string | undefined,
      takeoutArea: obj['takeoutArea'] as number | undefined,
      area: obj['area'] as number | undefined,
      name: obj['name'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      type_: obj['type'] as string | undefined,
      imageUrl: obj['imageUrl'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfRoom instances
   */
  static deserializeArray(json: string): SfRoom[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfRoom instance to a JSON string
   */
  static serialize(instance: SfRoom): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfRoom instance to a plain object
   */
  static toObject(instance: SfRoom): any {
    return {
      'externalId': instance.externalId,
      'isDeleted': instance.isDeleted,
      'floorplanExternalId': instance.floorplanExternalId,
      'floorplanExternalId|Name': instance.floorplanExternalIdName,
      'takeoutArea': instance.takeoutArea,
      'area': instance.area,
      'name': instance.name,
      'notes': instance.notes,
      'perimeter': instance.perimeter,
      'type': instance.type_,
      'imageUrl': instance.imageUrl,
    };
  }

  /**
   * Serializes an array of SfRoom instances to a JSON string
   */
  static serializeArray(instances: SfRoom[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
